import {menusRoute, constantRoutes} from '@/router'
import Layout from '@/layout'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = {...route}
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  alreayGeneraterMenus: false
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = constantRoutes.concat(routes)
  },
  UPDATE_MENUS_STATUS: (state, status) => {
    state.alreayGeneraterMenus = status;
  },
  ADD_MENU_ROUTES: (state, routes) => {
    state.routes = state.routes.concat(routes)
  }
}

const actions = {
  generateRoutes({commit}, menus) {
    return new Promise(resolve => {
      let accessedRoutes = menus.map(menu => {
        let children = menu.children && menu.children.length > 0 ? menu.children : [Object.assign(menu, {copy: true})];
        let routerObj = {
          path: `/${menu.module}`,
          name: menu.module,
          meta: {
            title: menu.title,
            icon: menu.icon
          },
          hidden: !menu.hidden,
          component: Layout,
          children: getChildrenRoutes(children, menu, true)
        };
        if (!menu.children || menu.children == 0) {
          routerObj.redirect = `/${menu.module}/${menu.path}`;
        }
        return routerObj
      });

      function getChildrenRoutes(children, parent, first) {
        return children.map(child => {
          let childObj = {
            path: `${child.path}`,
            name: first ? child.module + child.path : parent.name + child.name,
            meta: {
              title: child.title,
              icon: child.icon
            },
            hidden: !child.hidden,
            copy: !!parent.copy,
            component: () => import(`@/pages/${child.module}/${child.path}`)
            // component: r => require.ensure([], () => r(require(`@/pages/${child.module}/${child.path}`)), 'Home')
          };
          if (child.children && child.children.length > 0) {
            childObj.children = getChildrenRoutes(child.children, childObj)
          }
          return childObj
        })
      }

      commit('SET_ROUTES', accessedRoutes);
      commit('UPDATE_MENUS_STATUS', true);
      let adminId = this.getters.adminId;
      if (adminId == 1) {
        commit('ADD_MENU_ROUTES', menusRoute);
        accessedRoutes = accessedRoutes.concat(menusRoute);
      }
      resolve(accessedRoutes)
    })
  },
  updateMenusStatus({commit}, status) {
    commit('UPDATE_MENUS_STATUS', status);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js